import { Box, Paper } from '@mui/material';
import ParticlesBg from 'particles-bg';
import React from 'react';
import jozi from '../../Assets/Images/joziLandscape.jpg';
import { makeStyles } from '@mui/styles';
import Gene20Header from './presentationHeader/gene20Header';
import { Gene20CoverContainer } from '../../layouts/layoutContainers';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
  },
  rootBox: {
    backgroundSize: 'cover',
    backgroundImage: `url(${jozi})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    width: '90%',
    height: '100vh',
  },
}));
const Gene20Presents = () => {
  const classes = useStyles();
  return (
    <Box height="100%" minHeight="100vh">
      <Box className={classes.rootBox}>
        <ParticlesBg
          num={30}
          density={500}
          type="square"
          color="#00ffff"
          bg={{
            position: 'absolute',
            zIndex: 0,
            width: '100%',
            height: '100vh',
            opacity: '1',
          }}
        />
      </Box>
      <Gene20Header />
    </Box>
  );
};

export default Gene20Presents;
